import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { Observable } from "rxjs";
import { map, take } from "rxjs/operators";
import { AuthenticationService } from "src/app/services/authentication.service";
import { StormwaterRoleEnum } from "src/app/shared/generated/enum/stormwater-role-enum";

@Injectable({ providedIn: "root" })
export class StormwaterEditAccessGuard implements CanActivate {
    constructor(private authenticationService: AuthenticationService, private router: Router) {}

    canActivate(): Observable<boolean> {
        return this.authenticationService.getCurrentUser().pipe(
            take(1),
            map((user) => {
                const isAdmin = user?.StormwaterRoleID === StormwaterRoleEnum.Admin;
                const isNormalWithJurisdiction =
                    user?.StormwaterRoleID === StormwaterRoleEnum.Normal && user?.HasStormwaterJurisdictions === true;
                if (!isAdmin && !isNormalWithJurisdiction) {
                    this.router.navigate(["/"]);
                    return false;
                }
                return true;
            })
        );
    }
}
